
// feature product silder
$('.feature_product_slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
// product image slider
$('.product_img').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});


//  product page on tab description 
$('#tabs li a:not(:first)').addClass('inactive');
$('.container').hide();
$('.container:first').show();
$('#tabs li a').click(function(){
    var t = $(this).attr('href');
    $('#tabs li a').addClass('inactive');        
    $(this).removeClass('inactive');
    $('.container').hide();
    $(t).fadeIn('slow');
    return false;
})
// scroll
$("#shere_product").click(function(){
    $(".shocial_icon").slideToggle("slow");
  });

$('#more_description').click(function(event) {
      $('html, body').animate({
        scrollTop: $(".hup_product-tab").offset().top - 50}, 2000);
  		$("#tabs li:first-child a").trigger('click');
});


  $( ".Product_review_star" ).on( "click", function( event ) {
     $('html, body').animate({
        scrollTop: $(".hup_product-tab").offset().top - 50}, 2000);
    $("#tabs li:nth-child(3) a").trigger('click');
  
});


